import { SubscriptionFeaturesTypes } from "../types/features";

export interface ISubscriptionFeature {
  name: SubscriptionFeaturesTypes;
  isActive: boolean;
}
